"use client";
import Breadcrumb, { BreadcrumbItem } from "@/components/common/breadcrumb";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import Certificate1 from "../../../public/assets/certificate/certificate1.jpg";
import Certificate2 from "../../../public/assets/certificate/certificate2.jpg";
import Certificate3 from "../../../public/assets/certificate/certificate3.jpg";
import Certificate4 from "../../../public/assets/certificate/certificate4.jpg";

interface Certificate {
  id: string;
  image: StaticImageData;
}

const Certificate: React.FC = () => {
  const certificates: Certificate[] = [
    { id: "cert1", image: Certificate1 },
    { id: "cert2", image: Certificate2 },
    { id: "cert3", image: Certificate3 },
    { id: "cert4", image: Certificate4 },
  ];

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: "Home", href: "/" },
    { label: "Certificates", href: "/certificate" },
  ];

  return (
    <div className="xl:mt-17 mt-1920-20">
      <Breadcrumb title="Certificates" items={breadcrumbItems} />

      <section className="pt-[50px] pb-[100px] px-[20px]">
        <div className="container mx-auto text-center">
          <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-10">
            {certificates.map((cert) => (
              <Link
                key={cert.id}
                href={cert.image.src}
                target="_blank"
                rel="noopener noreferrer"
                className="relative group cursor-pointer"
              >
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#d42427] via-[#033b6f] to-[#2d87db] opacity-15 blur-lg group-hover:opacity-100 group-hover:blur-2xl transition duration-500"></div>

                <div className="relative shadow border border-gray-200 rounded-2xl overflow-hidden bg-white backdrop-blur-sm transform transition duration-500 group-hover:scale-105 group-hover:rotate-1 group-hover:-translate-y-2">
                  <Image
                    src={cert.image}
                    alt="certificate"
                    width={500}
                    height={700}
                    className="w-full h-auto rounded-2xl"
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Certificate;
